const MinusIcon = () => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobBoard1920Copy2" transform="translate(-559, -412)" stroke="#141718" strokeWidth="2">
                    <g id="Group4Copy2" transform="translate(567, 420) rotate(-315) translate(-567, -420)translate(563, 416)">
                        <line x1="0" y1="8" x2="8" y2="0" id="Stroke1"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default MinusIcon;
